import Vue from 'vue'
import Router from 'vue-router'
// 登录
import login from './views/login/login.vue'
// 注册
import register from './views/login/register.vue'
// 忘记密码
import forget from './views/login/forget.vue'
// 首页
import index from './views/home/index.vue'
// 个人信息
import user from './views/home/user.vue'
// 搜索
import search from './views/home/search.vue'
// 详情
import detail from './views/home/detail.vue'
// 首页案例详情
import HomeCaseDetails from './views/home/HomeCaseDetails.vue'
// 服务列表
import serveList from './views/home/serveList.vue'
// 下单
import placeOrder from './views/home/placeOrder.vue'
// 保险下单
import insuranceOrder from './views/home/insuranceOrder.vue'
// 支付
import pay from './views/pay/pay.vue'
// 支付成功
import paySuccess from './views/pay/paySuccess.vue'
// 订单
import order from './views/order/order.vue'
// 订单详情
import orderDetails from './views/order/orderDetails.vue'
// 查看照片
import see from './views/order/see.vue'
// 超时 取消
import overtimeCancel from './views/order/overtimeCancel.vue'
// 取消
import cancel from './views/order/cancel.vue'
// 成功
import success from './views/order/success.vue'
// 通知提醒
import noticeRemind from './views/order/noticeRemind.vue'
// 紧急上报原因
import report from './views/order/report.vue'
// 申请退款
import applyRefund from './views/order/applyRefund.vue'
// 申请售后
import applyAftersales from './views/order/applyAftersales.vue'
// 选择查看进度、报告
import schedule from './views/workProgress/schedule.vue'
// 监装分类列表
import list from './views/workProgress/list.vue'
// 监装下级分类列表
import lowerList from './views/workProgress/lowerList.vue'

// 查看工作进度-监装
import workProgress from './views/workProgress/workProgress.vue'
// 开始工作
import workStart1 from './views/workProgress/workStart1.vue'
import workStart2 from './views/workProgress/workStart2.vue'
import workStart3 from './views/workProgress/workStart3.vue'
import workStart4 from './views/workProgress/workStart4.vue'
import workStart5 from './views/workProgress/workStart5.vue'
// 查看工作报告
import workReport from './views/workProgress/workReport.vue'
// 查看证书图片
import certificatePicture from './views/workProgress/certificatePicture.vue'
// 查看工作进度-量油
import ly from './views/workProgress/ly.vue'
// 查看工作进度-加油
import jy from './views/workProgress/jy.vue'
import newJy from './views/workProgress/newJy.vue'
import newLy from './views/workProgress/newLy.vue'
// 查看工作进度-水尺
import sc from './views/workProgress/sc.vue'
// 查看工作进度-保险
import bx from './views/workProgress/bx.vue'
import kh from './views/workProgress/kh.vue'
import zb from './views/workProgress/zb.vue'
import rb from './views/workProgress/rb.vue'
import khb from './views/workProgress/khb.vue'
// 去评价
import evaluate from './views/order/evaluate.vue'
// 我的收藏
import cllection from './views/cllection/cllection.vue'
// 投诉建议
import proposal from './views/proposal/proposal.vue'
// 常见问题
import problem from './views/problem/problem.vue'
// 关于我们
import about from './views/about/about.vue'
// 案例详情
import caseDetails from './views/home/caseDetails.vue'
// 协议
import agreement from './views/agreement/agreement.vue'
// import styleshow from './views/ceshi/styleshow.vue'
// import styleTest from './views/ceshi/styleTest.vue'
// import styleTestCheck from './views/ceshi/styleTestCheck.vue'
// h5 邀请注册
import invite from './views/h5/invite'
import pgyer from './views/h5/pgyer'

Vue.use(Router)

export default new Router({
	mode: 'hash',
	// base: '/jianyanshiWeb',
	routes: [{
		path: '/',
		name: 'login',
		component: login
	},
	{
		path: '/register',
		name: 'register',
		component: register
	},
	// {
	// 	path: '/styleshow',
	// 	name: 'styleshow',
	// 	component: styleshow
	// },
	// {
	// 	path: '/styleTest',
	// 	name: 'styleTest',
	// 	component: styleTest
	// },
	// {
	// 	path: '/styleTestCheck',
	// 	name: 'styleTestCheck',
	// 	component: styleTestCheck
	// },
	{
		path: '/list',
		name: 'list',
		component: list
	},
	{
		path: '/lowerList',
		name: 'lowerList',
		component: lowerList
	},
	{
		path: '/kh',
		name: 'kh',
		component: kh
	},
	{
		path: '/zb',
		name: 'zb',
		component: zb
	},
	{
		path: '/rb',
		name: 'rb',
		component: rb
	},
	{
		path: '/khb',
		name: 'khb',
		component: khb
	},
	{
		path: '/forget',
		name: 'forget',
		component: forget
	},
	{
		path: '/index',
		name: 'index',
		component: index
	},
	{
		path: '/user',
		name: 'user',
		component: user
	},
	{
		path: '/search',
		name: 'search',
		component: search
	},
	{
		path: '/detail',
		name: 'detail',
		component: detail
	},
	{
		path: '/HomeCaseDetails',
		name: 'HomeCaseDetails',
		component: HomeCaseDetails
	},
	{
		path: '/serveList',
		name: 'serveList',
		component: serveList
	},
	{
		path: '/placeOrder',
		name: 'placeOrder',
		component: placeOrder
	},
	{
		path: "/insuranceOrder",
		name: "insuranceOrder",
		component: insuranceOrder
	},
	{
		path: '/pay',
		name: 'pay',
		component: pay
	},
	{
		path: "/paySuccess",
		name: 'paySuccess',
		component: paySuccess
	},
	{
		path: "/order",
		name: 'order',
		component: order
	},
	{
		path: "/orderDetails",
		name: 'orderDetails',
		component: orderDetails
	},
	{
		path: "/see",
		name: 'see',
		component: see
	},
	{
		path: "/overtimeCancel",
		name: 'overtimeCancel',
		component: overtimeCancel
	},
	{
		path: "/cancel",
		name: 'cancel',
		component: cancel
	},
	{
		path: "/success",
		name: 'success',
		component: success
	},
	{
		path: "/noticeRemind",
		name: 'noticeRemind',
		component: noticeRemind
	},
	{
		path: "/report",
		name: 'report',
		component: report
	},
	{
		path: "/applyRefund",
		name: 'applyRefund',
		component: applyRefund
	},
	{
		path: "/applyAftersales",
		name: 'applyAftersales',
		component: applyAftersales
	},
	{
		path: "/schedule",
		name: 'schedule',
		component: schedule
	},
	{
		path: "/workProgress",
		name: 'workProgress',
		component: workProgress
	},
	{
		path: "/workStart1",
		name: 'workStart1',
		component: workStart1
	},
	{
		path: "/workStart2",
		name: 'workStart2',
		component: workStart2
	},
	{
		path: "/workStart3",
		name: 'workStart3',
		component: workStart3
	},
	{
		path: "/workStart4",
		name: 'workStart4',
		component: workStart4
	},
	{
		path: "/workStart5",
		name: 'workStart5',
		component: workStart5
	},
	{
		path: "/workReport",
		name: 'workReport',
		component: workReport
	},
	{
		path: "/certificatePicture",
		name: "certificatePicture",
		component: certificatePicture
	},
	{
		path: "/ly",
		name: "ly",
		component: ly
	},
	{
		path: "/jy",
		name: "jy",
		component: jy
	},
	{
		path: "/newJy",
		name: "newJy",
		component: newJy
	},
	{
		path: "/newLy",
		name: "newLy",
		component: newLy
	},
	{
		path: "/sc",
		name: "sc",
		component: sc
	},
	{
		path: "/bx",
		name: "bx",
		component: bx
	},
	{
		path: "/evaluate",
		name: "evaluate",
		component: evaluate
	},
	{
		path: "/cllection",
		name: "cllection",
		component: cllection
	},
	{
		path: "/proposal",
		name: "proposal",
		component: proposal
	},
	{
		path: "/problem",
		name: "problem",
		component: problem
	},
	{
		path: "/about",
		name: "about",
		component: about
	},
	{
		path: '/caseDetails',
		name: "caseDetails",
		component: caseDetails
	},
	{
		path: '/agreement',
		name: "agreement",
		component: agreement
	},
	{
		path: '/invite',
		name: 'invite',
		component: invite
	},
	{
		path: '/pgyer',
		name: 'pgyer',
		component: pgyer
	},
	],
	scrollBehavior (to, from, savedPosition) {
		return {
			x: 0,
			y: 0
		}
	}
})
